import { Component, OnInit } from '@angular/core'
import { FormFieldFactoryComponentAbstract } from '../../core/component/form-field-factory/form-field-factory.component-abstract'

@Component({
    selector: 'mga-form-factory-field-datepicker',
    templateUrl: './form-factory-field-datepicker.component.html',
    styleUrls: ['./form-factory-field-datepicker.component.scss'],
})
export class FormFactoryFieldDatepickerComponent extends FormFieldFactoryComponentAbstract {}
